import { useState, useEffect } from "react";

export default function Duplicates({ data }) {
  const [userDuplicates, setUserDuplicates] = useState();

  useEffect(() => {
    if (data && data.enquiry_duplicates && data.enquiry_duplicates.length > 0) {
      setUserDuplicates(data.enquiry_duplicates);
    }
  }, [data]);

  // console.log("line 766:",data)
  return (
    <div className="duplicatesContainer">
      {userDuplicates && userDuplicates.length > 0 ? (
        <table className="duplicate-table table table-responsive table-hover">
          <thead>
            <tr>
              <th>Name</th>
              <th>Program</th>
              <th>Email</th>
              <th>Phone</th>
              <th>Origin</th>
            </tr>
          </thead>
          <tbody>
            {userDuplicates.map((item) => (
              <tr key={item.id}>
                <td style={{ textTransform: "capitalize" }}>{item.name}</td>
                <td>{item.program}</td>
                <td>{item.email}</td>
                <td>{item.mobile_number}</td>
                <td>{item.form_location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      ) : (
        <p
          style={{
            margin: 0,
            color: "#6B7280",
            fontSize: "13px",
            fontFamily: "Inter",
          }}
        >
          No duplicates found for this lead.
        </p>
      )}
    </div>
  );
}
